import { TimeFormatOptions, User } from '@griply/types';

import { getTimeFormat } from './get-time-format';

const TIME_FORMAT_PATTERNS: Record<TimeFormatOptions, string> = {
  [TimeFormatOptions.Military]: 'HH:mm',
  [TimeFormatOptions.Standard]: 'h:mm a',
};

export const getTimeFormatPattern = (user?: User | null): string =>
  TIME_FORMAT_PATTERNS[getTimeFormat(user)];
